import CorelogicApiService from './CorelogicApiService';

export default class PropertyService extends CorelogicApiService {
  getById(identifier, data, fullResponse) {
    const getData = Object.assign({}, data, { id: identifier });
    return this.get('/Property/details', getData, null, fullResponse);
  }
}
